import { render } from "./SearchItems.vue?vue&type=template&id=6d6c4626"
import script from "./SearchItems.vue?vue&type=script&lang=js"
export * from "./SearchItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__